module.exports = __webpack_public_path__ + "static/remuda-court-plat-map-1838b1a2218631eb732658d64704d08a.jpg";